import { useEffect } from "react";

import { TemplateCategory } from "@/components/confluence/templates/template-categories-search";
import type { Template } from "@/content/templates/template.types";
import { ConfluenceTemplateCategoryPageTemplate } from "@/templates/software/confluence/templates/confluence-templates-page/src";
import { experiments, useExperimentExposure } from "@/utils/experiment";

export type ConfluenceTemplateCategoryPageProps = {
    templates?: Template[];
    partnerTemplates?: Template[];
    categories?: TemplateCategory[];
};

export const ConfluenceTemplateCategoryPage = ({
    templates,
    partnerTemplates,
    categories
}: ConfluenceTemplateCategoryPageProps) => {
    const [relayExposureFired, fireRelayExposure] = useExperimentExposure(
        experiments.gwpAddRelayToConfluenceTemplateCategories
    );

    useEffect(() => {
        if (!relayExposureFired) {
            fireRelayExposure();
        }
    }, [relayExposureFired, fireRelayExposure]);

    return (
        <ConfluenceTemplateCategoryPageTemplate
            templates={templates}
            partnerTemplates={partnerTemplates}
            categories={categories}
        />
    );
};
